import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Badge } from 'react-bootstrap';
import { publicAPI } from '../services/api';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      const result = await publicAPI.getCourses();
      if (result && result.success) {
        setCourses(result.data || []);
      } else {
        setError('Failed to load courses');
      }
    } catch (error) {
      console.error('Error fetching courses:', error);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <h1 className="display-4 mb-4 text-center">Our Courses</h1>
      <p className="lead text-center mb-5">
        Explore our wide range of academic programs and courses
      </p>

      {error && (
        <Alert variant="danger" className="mb-4">
          {error}
        </Alert>
      )}

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Loading courses...</p>
        </div>
      ) : courses.length > 0 ? (
        <Row>
          {courses.map((course) => (
            <Col key={course.id} lg={6} className="mb-4">
              <Card className="h-100 shadow-sm card-hover">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <Card.Title className="text-primary mb-0">
                      <i className="fas fa-book me-2"></i>
                      {course.name}
                    </Card.Title>
                    {course.code && (
                      <Badge bg="secondary">{course.code}</Badge>
                    )}
                  </div>
                  
                  {course.description && (
                    <Card.Text className="text-dark">
                      {course.description}
                    </Card.Text>
                  )}
                  
                  <div className="mt-4">
                    {course.duration && (
                      <div className="mb-2">
                        <strong>Duration:</strong> {course.duration}
                      </div>
                    )}
                    {course.eligibility && (
                      <div className="mb-2">
                        <strong>Eligibility:</strong> {course.eligibility}
                      </div>
                    )}
                    {course.fee && (
                      <div className="mb-2">
                        <strong>Fee:</strong> ₹{course.fee}
                      </div>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="text-center py-5">
          <i className="fas fa-book-open fa-3x text-muted mb-3"></i>
          <h3>No Courses Found</h3>
          <p className="text-muted">Course information will be available soon.</p>
        </div>
      )}
    </Container>
  );
};

export default Courses;